import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import axios from "../../api/axiosInstance";
import "./EventDetails.css";
import AppStatusScreen from "../AppStatusScreen/AppStatusScreen";
import KitButton from "../kit/Button";
import IconButton from "../kit/IconButton";
import ActionTile from "../kit/ActionTile";
import Badge from "../kit/Badge";
import Chip from "../kit/Chip";
import { Card } from "../kit/Card";
import ImageSlider from "../ImageSlider/ImageSlider";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import { enqueueSnackbar } from "notistack";
import { RiFlag2Line } from "react-icons/ri";
import { formatPosterAccount } from "../../util/dataUtils";
import { MdTune } from "react-icons/md";
import { IoFilter } from "react-icons/io5";
import InfiniteScroller from "../InfiniteScroller/InfiniteScroller";
import MiniMap from "../MiniMap/MiniMap";
import EventCard from "../EventCard/EventCard";
import { useAnalytics } from "../../context/AnalyticsContext/AnalyticsProvider";
import { useData } from "../../context/DataContext/DataProvider";
import { useUser } from "../../context/UserContext/UserProvider";
// Lazy load QRCode to reduce initial bundle size and improve first load
const QRCode = React.lazy(() => 
  import("react-qrcode-logo").then(module => ({ default: module.QRCode }))
);
import { Directory, Filesystem } from "@capacitor/filesystem";

import { FaInstagram } from "react-icons/fa";
import { IoIosLink } from "react-icons/io";
import { Instagram } from "capacitor-instagram-share";
import { LuCalendarPlus } from "react-icons/lu";
import { modal } from "../../util/useModal";
import { FACEBOOK_APP_ID, backendUrl } from "../../api/constants";
import { domToPng } from "modern-screenshot";
import { TbPhotoShare } from "react-icons/tb";
import { IoCopyOutline } from "react-icons/io5";
import { MdQrCode2 } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import Tabs, { TabContent } from "../ui/tabs";
import { Share } from "@capacitor/share";
import { useLogger } from "../../context/LogContext/LogProvider";
import { formatSlotOccurrenceTimeRange } from "../../util/eventDateTime";
import {
  defaultDate,
  distance,
  formatDateTime,
  isDefaultDateFilter,
} from "../../util/eventUtils";
import { trackTransformation } from "../../util/debugUtils";
import { useUIContext } from "../../context/UIContext/UIContext";
import { Clipboard } from "@capacitor/clipboard";
import { FaChevronDown, FaEye, FaRegEye, FaUser } from "react-icons/fa6";
import { FaGoogle } from "react-icons/fa";
import { IoShareOutline } from "react-icons/io5";
import { useOutsideAlerter } from "../../util/useOutsideAlerter";
import { Link } from "react-router-dom";
import { FaCheck } from "react-icons/fa";
import { BottomSheetDateFilter } from "../Map/Map";
import { useEventDetails } from "../../context/EventDetailsProvider/EventDetailsProvider";
import Input from "../Input/Input";
import Loader from "../icons/Loader";
import LocationSVG from "../icons/LocationSVG";
import { FiSearch } from "react-icons/fi";
import { useAccountDetailsSetters } from "../../context/AccountDetailsContext/AccountDetailsProvider";
import { loadIcon } from "../../util/iconRegistry";
import { getEventCategoryClass } from "../../util/categoryStyles";
import { CapacitorCalendar } from "@ebarooni/capacitor-calendar";
import { Capacitor } from "@capacitor/core";
import SocialsView, {
  hasMediaEmbeds,
  splitIconAndNamedSocials,
} from "../SocialsInput/SocialsView";
import SocialButton from "../SocialButton/SocialButton";
import { TbTicket } from "react-icons/tb";
import { openDirections } from "../../util/mapDirections";
import { DateTime } from "luxon";
import { MdRestaurant, MdLocalBar, MdWbSunny } from "react-icons/md";


const ensureValidUrl = (url) => {
  if (!url) return url;
  if (/^(https?:)?\/\//i.test(url)) {
    return url;
  }
  return `https://${url}`;
};

const normalizeLocationText = (value = "") =>
  value.trim().toLowerCase().replace(/\s+/g, " ");

const isAddressLikeLocationName = (value = "") => {
  const normalized = normalizeLocationText(value);
  return !normalized || /^\d+\s/.test(normalized);
};

const stripAddressPrefix = (address = "", prefix = "") => {
  if (!address || !prefix) return address;

  const normalizedAddress = normalizeLocationText(address);
  const normalizedPrefix = normalizeLocationText(prefix);

  if (!normalizedAddress.startsWith(`${normalizedPrefix},`)) {
    return address;
  }

  return address.slice(address.indexOf(",") + 1).trim();
};

const getLegacyGoogleLocationName = (address = "") => {
  const parts = address.split(",").map((part) => part.trim()).filter(Boolean);
  if (parts.length < 4) return "";

  const [possibleName] = parts;
  return isAddressLikeLocationName(possibleName) ? "" : possibleName;
};

const EventReportDropDown = ({ open, onReport, type = "event" }) => {
  const [selectedReason, setSelectedReason] = useState(null);
  const [notes, setNotes] = useState("");

  useEffect(() => {
    if (!open) {
      setSelectedReason(null);
      setNotes("");
    }
  }, [open]);

  const reasons = [
    { id: "i_found_a_bug", label: "bug", placeholder: "what happened? more info helps us repair faster", notesRequired: true },
    { id: "not_a_real_event", label: "false event", placeholder: "what's wrong with this event?" },
    { id: "incorrect_information", label: "incorrect info", placeholder: "what info is wrong?" },
    { id: `i_did_not_like_this_${type}`, label: "did not like", placeholder: "what didn't you like?" },
  ];

  const selected = reasons.find((reason) => reason.id === selectedReason);
  const canSubmit = Boolean(selected) && (!selected.notesRequired || notes.trim());

  return (
    <div 
      className={`inyc-menu flex-col w-[14rem] max-w-[70vw] absolute top-[48px] right-0 duration-200 z-[10000] ${
        open
          ? "pointer-events-all opacity-100"
          : "opacity-0 translate-y-[-10px] pointer-events-none"
      }`}
      onClick={(e) => {
        e.stopPropagation();
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
    >
      <div className="inyc-label is-sm !mb-0 px-kit-12 pt-kit-8 pb-kit-6 text-center !text-danger">report!</div>
      <div className="flex flex-col">
        {reasons.map((reason) => (
          <React.Fragment key={reason.id}>
            <button
              type="button"
              className={`inyc-menu-item ${selectedReason === reason.id ? "is-selected" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                setSelectedReason(reason.id);
              }}
            >
              {reason.label}
            </button>
            {selectedReason === reason.id && (
              <div className="inyc-fields flex flex-col gap-kit-8 px-kit-4 pt-kit-6 pb-kit-8">
                <Input
                  multiLine
                  placeHolder={reason.placeholder}
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  inputStyle={{ minHeight: "4.5rem", resize: "none" }}
                />
                <KitButton
                  variant="primary"
                  size="sm"
                  fullWidth
                  disabled={!canSubmit}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!canSubmit) return;
                    onReport(reason.id, notes.trim());
                  }}
                >
                  submit
                </KitButton>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

// const EventCalendarDropDown = ({ open, setOpen, eventId }) => {
//   const { setUIData } = useUIContext();
//   const { calendarAccounts, fetchCalendarAccounts } = useUser();
//   const handleAddToCalendar = (account) => async (e) => {
//     e.stopPropagation();
//     try {
//       const { data } = await axios.post(`/user/calendar/google/add-event`, {
//         accountId: account._id,
//         eventId: eventId,
//       });
//       if (data.error) {
//         return enqueueSnackbar(data.error, { variant: "error" });
//       }
//       await fetchCalendarAccounts();
//       setOpen(false);
//       return enqueueSnackbar("event added to calendar", { variant: "success" });
//     } catch (error) {
//       console.error(error);
//       return enqueueSnackbar("something went wrong", { variant: "error" });
//     }
//   };

//   return (
//     <div
//       className={`rounded-kit-xs bg-[var(--inyc-primary)] !justify-start flex-col shadow-kit-md max-w-[70vw] absolute top-[40px] right-[50%] translate-x-[50%] min-w-[150px] overflow-hidden duration-200 ${
//         open
//           ? "pointer-events-all"
//           : "opacity-0 translate-y-[-10px] pointer-events-none"
//       }`}
//       id="event-calendar-dropdown-container"
//     >
//       {calendarAccounts?.length > 0 ? (
//         calendarAccounts.map((account) => (
//           <div
//             className="px-kit-16 py-kit-8 hover:bg-hover duration-200 flex items-start justify-start gap-kit-10"
//             key={account._id}
//             id="event-calendar-dropdown-item"
//             onClick={handleAddToCalendar(account)}
//           >
//             {account.items?.find(
//               (item) => item.eventId === eventId?.toString()
//             ) && <FaCheck className="text-success" size={10} />}
//             {account.service === "google" && <FaGoogle size={15} />}
//             <div className="flex-col !items-start">
//               <div className="leading-[1rem]">{account.meta.name}</div>
//               <div className="text-black/60 text-kit-xs">
//                 {account.meta.email}
//               </div>
//             </div>
//           </div>
//         ))
//       ) : (
//         <div className="p-kit-16 text-center text-kit-xs leading-[1rem] text-black/60">
//           <div className="flex-col">
//             you have no connected calendar accounts
//             <br />
//             <br />
//             click{" "}
//             <Link
//               onClick={() => {
//                 setUIData((prev) => ({
//                   ...prev,
//                   selectedEvent: null,
//                   selectedSubEvent: null,
//                 }));
//               }}
//               className="inline-block"
//               to="dashboard?tab=calendar"
//             >
//               here
//             </Link>{" "}
//             to connect a calendar account
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

const sanitizeDescriptionText = (description) => {
  if (!description) return "";

  return description.replace(/\n{3,}/g, "\n\n");
};

const shouldExpandDescriptionByDefault = (item) => {
  const descriptionLength = sanitizeDescriptionText(item?.description).length;

  return item?.type === "venue" || (descriptionLength > 0 && descriptionLength <= 500);
};

const hasTicketValue = (value) => Boolean(value && value !== "$");

const formatTicketPrice = (ticket) => {
  const priceType = ticket?.priceType || 'priced_at';
  const price = hasTicketValue(ticket?.price) ? ticket.price : "";
  const priceMax = hasTicketValue(ticket?.priceMax) ? ticket.priceMax : "";

  switch (priceType) {
    case 'starting_at':
      return price ? `Starting at ${price}` : null;
    case 'donation':
      return price || 'Donation';
    case 'rsvp':
      return price || 'RSVP';
    case 'door':
      return price ? `${price} at the door` : 'At the door';
    case 'range':
      return price && priceMax ? `${price} - ${priceMax}` : price || null;
    case 'priced_at':
    default:
      return price || null;
  }
};

const isDisplayableTicket = (ticket) =>
  Boolean(
    ticket?.link ||
    ticket?.name ||
    ticket?.description ||
    hasTicketValue(ticket?.price) ||
    hasTicketValue(ticket?.priceMax) ||
    ticket?.priceType === 'donation' ||
    ticket?.priceType === 'rsvp'
  );

const getDisplayTickets = (event) => {
  if (!event) return [];

  if (Array.isArray(event.tickets) && event.tickets.length > 0) {
    return event.tickets.filter(isDisplayableTicket);
  }

  if (event.ticket_link || hasTicketValue(event.ticket_price)) {
    return [
      {
        name: "",
        priceType: "priced_at",
        price: event.ticket_price || "",
        priceMax: "",
        description: "",
        link: event.ticket_link || "",
      },
    ].filter(isDisplayableTicket);
  }

  return [];
};

const openTicketLink = ({ ticket, event, trackSessionEvent, source, ensureValidUrl }) => {
  if (!ticket?.link) return;

  trackSessionEvent({
    action: `${event.type} ticket clicked`,
    category: event.type,
    label: `${event.type}_ticket_clicked`,
    [event.type]: event._id,
    value: {
      name: event.name,
      address: event.address,
      category: event.category,
      ticketLink: ticket.link,
      ticketName: ticket.name,
      tierName: ticket.name,
      source,
    },
    timestamp: Date.now(),
  });
  window.open(ensureValidUrl(ticket.link), "_blank");
};

// Ticket cards section component - extracted to avoid hooks in IIFE
const TicketCardsSection = ({ event, trackSessionEvent, ensureValidUrl, previewOnly = false }) => {
  const [ticketsExpanded, setTicketsExpanded] = useState(false);
  const tickets = getDisplayTickets(event);

  if (tickets.length === 0) return null;

  const ticketsLabel = <div className="inyc-label">tickets</div>;

  const TicketCard = ({ ticket }) => (
    <Card padding="sm">
      {(ticket.name || formatTicketPrice(ticket)) && (
        <div className="mb-kit-4 flex items-baseline justify-between gap-kit-12">
          {ticket.name && (
            <div className="font-['Primary-Regular'] text-kit-base text-[var(--inyc-primary-text-color)]">
              {ticket.name}
            </div>
          )}
          {formatTicketPrice(ticket) && (
            <div className="shrink-0 text-right font-['Primary-Regular'] text-kit-base text-[var(--inyc-primary-text-color)]">
              {formatTicketPrice(ticket)}
            </div>
          )}
        </div>
      )}
      <div className="flex items-start justify-between gap-kit-16">
        {ticket.description && (
          <div className="inyc-help is-sm flex-1 whitespace-pre-wrap">
            {ticket.description}
          </div>
        )}
        {ticket.link && !previewOnly && (
          <KitButton
            size="sm"
            className="ml-auto"
            iconRight={<TbTicket className="rotate-[-90deg]" />}
            onClick={() => openTicketLink({
              ticket,
              event,
              trackSessionEvent,
              source: "event_details_ticket_card",
              ensureValidUrl,
            })}
          >
            get tickets
          </KitButton>
        )}
      </div>
    </Card>
  );
  
  // Single ticket - show card directly, even when it only has a price.
  if (tickets.length === 1) {
    return (
      <div className="mt-[var(--inyc-details-stack-gap)]">
        {ticketsLabel}
        <TicketCard ticket={tickets[0]} />
      </div>
    );
  }
  
  // Multiple tickets - show expandable dropdown
  if (tickets.length > 1) {
    return (
      <div className="mt-[var(--inyc-details-stack-gap)]">
        <button
          type="button"
          onClick={() => setTicketsExpanded(!ticketsExpanded)}
          className="inyc-label flex w-full items-center justify-between"
        >
          <span>tickets</span>
          <FaChevronDown
            size={10}
            className={`duration-200 ${ticketsExpanded ? "rotate-180" : ""}`}
          />
        </button>
        
        <div className={`grid duration-300 ${ticketsExpanded ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
          <div className="overflow-hidden">
            <div className="flex flex-col gap-kit-12">
              {tickets.map((ticket, index) => (
                <TicketCard key={index} ticket={ticket} />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  return null;
};

// Ticket button component - extracted to avoid hooks in IIFE
const TicketButton = ({ tickets, event, trackSessionEvent, ensureValidUrl }) => {
  const [ticketMenuOpen, setTicketMenuOpen] = useState(false);
  const ticketMenuRef = useRef(null);
  
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ticketMenuRef.current && !ticketMenuRef.current.contains(e.target)) {
        setTicketMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (!tickets || tickets.length === 0) return null;

  // Single ticket - direct button
  if (tickets.length === 1) {
    const [ticket] = tickets;

    return (
      <IconButton
        variant="secondary"
        shape="box"
        size="md"
        className="event-details-action-btn"
        label="tickets"
        icon={<TbTicket className="rotate-[-90deg]" size={20} />}
        onClick={() => {
          openTicketLink({
            ticket,
            event,
            trackSessionEvent,
            source: "event_details_ticket_button",
            ensureValidUrl,
          });
        }}
      />
    );
  }

  // Multiple tickets - dropdown menu
  return (
    <div 
      className="relative"
      ref={ticketMenuRef}
    >
      <IconButton
        variant="secondary"
        shape="box"
        size="md"
        className="event-details-action-btn"
        label="tickets"
        icon={<TbTicket className="rotate-[-90deg]" size={20} />}
        onClick={() => setTicketMenuOpen(!ticketMenuOpen)}
      />
      
      {ticketMenuOpen && (
        <div className="inyc-menu absolute top-[48px] left-1/2 -translate-x-1/2 w-[13rem] max-w-[70vw] z-[1002]">
          {tickets.map((ticket, index) => (
            <button
              key={index}
              type="button"
              disabled={!ticket.link}
              onClick={() => {
                if (!ticket.link) return;
                openTicketLink({
                  ticket,
                  event,
                  trackSessionEvent,
                  source: "event_details_ticket_menu",
                  ensureValidUrl,
                });
                setTicketMenuOpen(false);
              }}
              className="inyc-menu-item justify-between disabled:cursor-default"
            >
              <span className="flex flex-col gap-kit-2">
                {ticket.name && <span>{ticket.name}</span>}
                {formatTicketPrice(ticket) && (
                  <span className="inyc-help is-sm">{formatTicketPrice(ticket)}</span>
                )}
              </span>
              <TbTicket className="rotate-[-90deg] shrink-0 opacity-40" size={16} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const EventDetails = ({
  data,
  parentRef,
  className,
  onGetDirections = (event) => {
    openDirections(event.location?.coordinates);
  },
  onSelectEvent,
  Close,
  sheetLayout = false,
  useAsAnalytics,
  previewOnly = false,
}) => {


  const [reportOpen, setReportOpen] = useState(false);
  const [venueFilterOpen, setVenueFilterOpen] = useState(false);
  const [event, setEvent] = useState(data); // Initialize with data immediately
  

  const { user } = useUser();
  const searchInputRef = useRef();

  // Handle Enter key to dismiss keyboard on iOS
  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      // Blur the input to dismiss the keyboard
      if (searchInputRef.current) {
        searchInputRef.current.blur();
      }
    }
  };

  // Memoized onClick handler for EventCard to prevent unnecessary re-renders
  const handleEventCardClick = useCallback((item) => {
    onSelectEvent(item);
  }, [onSelectEvent]);

  const {
    toggleFollowUser,
    shareEvent: updateShareEvent,
    userLocation,
    globalConfig,
  } = useData();
  
  // Memoize extracted values from globalConfig to prevent re-creating on every render
  const categories = useMemo(() => globalConfig?.categories || [], [globalConfig?.categories]);
  const knownServices = useMemo(() => globalConfig?.knownServices || {}, [globalConfig?.knownServices]);
  const {
    dateFilter,
    setDateFilter,
    tagFilter,
    setTagFilter,
    queryFilter,
    setQueryFilter,
    filteredEvents,
    detailsSearchLoading,
    selectedEvent,
    selectedSubEvent,
    setSelectedSubEvent,
  } = useEventDetails();
  

  
  // PERFORMANCE: Sync event state only when data._id changes (not on every event state change)
  // This prevents re-render loops while ensuring we update when parent passes new data
  useEffect(() => {
    if (data?._id && data._id !== event?._id) {
      setEvent(data);
    }
  }, [data?._id]); // Only depend on data._id, not 'event' to avoid loops
  
  const { selectAccount } = useAccountDetailsSetters();
  const { trackSessionEvent } = useAnalytics();
  const { availableApps, likeEvent, likedEvents, activeCategories } =
    useUIContext();
  const { startLog } = useLogger();
  const [calendarListOpen, setCalendarListOpen] = useState(false);
  const calendarAddRef = useRef();
  const reportRef = useRef();
  useOutsideAlerter(calendarAddRef, () => setCalendarListOpen(false));
  useOutsideAlerter(reportRef, () => setReportOpen(false));
  const [showFullDescription, setShowFullDescription] = useState(() => shouldExpandDescriptionByDefault(data));
  const [detailMediaPage, setDetailMediaPage] = useState(0);
  const detailPagerTouchStart = useRef(null);
  const characterLimit = 200;

  // Memoize MiniMap style to prevent re-renders
  const miniMapStyle = useMemo(() => ({ height: "200px" }), []);
  const detailImages = useMemo(() => {
    if (event?.images?.length > 0) return event.images;
    if (event?.venueImages?.length > 0) return event.venueImages;
    return [];
  }, [event?.images, event?.venueImages]);
  const hasDetailImages = detailImages.length > 0;
  const sanitizedDescription = sanitizeDescriptionText(event?.description);
  const hasDescriptionText = sanitizedDescription.length > 0;
  const hasLongDescription = sanitizedDescription.length > 500;
  const detailPages = useMemo(() => {
    if (event?.type === "venue") {
      return [
        { id: "events", label: "events" },
        ...(hasDetailImages ? [{ id: "photos", label: "images" }] : []),
        { id: "details", label: "story" },
        { id: "search", label: "search" },
      ];
    }

    return [
      { id: "details", label: "what to expect:" },
      ...(hasDetailImages ? [{ id: "photos", label: "images" }] : []),
    ];
  }, [event?.type, hasDetailImages]);
  const activeDetailPage = detailPages[detailMediaPage]?.id || detailPages[0]?.id || "details";
  const venueSearchOpen = activeDetailPage === "search";
  const isVenueEventsView = activeDetailPage === "events" || activeDetailPage === "search";
  const showDetailPageDots = detailPages.length > 1 || (event?.type !== "venue" && hasDescriptionText);
  const showMediaEmbeds = hasMediaEmbeds(event?.socials);
  // tabs keep their order; the selected one is underlined in place
  const visibleDetailPages = detailPages;

  const handleDetailPagerTouchStart = (e) => {
    const touch = e.touches?.[0];
    if (!touch) return;

    detailPagerTouchStart.current = {
      x: touch.clientX,
      y: touch.clientY,
    };
  };

  const handleDetailPagerTouchEnd = (e) => {
    if (detailPages.length <= 1 || !detailPagerTouchStart.current) return;

    const touch = e.changedTouches?.[0];
    if (!touch) return;

    const deltaX = touch.clientX - detailPagerTouchStart.current.x;
    const deltaY = touch.clientY - detailPagerTouchStart.current.y;
    detailPagerTouchStart.current = null;

    if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;

    setDetailMediaPage((currentPage) => {
      const nextPage = currentPage + (deltaX < 0 ? 1 : -1);
      return Math.max(0, Math.min(nextPage, detailPages.length - 1));
    });
  };

  useEffect(() => {
    if (detailMediaPage > detailPages.length - 1) {
      setDetailMediaPage(0);
    }
  }, [detailMediaPage, detailPages.length]);

  // Auto-open venue filter panel only when actual filters are active (not just search query)
  useEffect(() => {
    if (event?.type === "venue") {
      const hasActiveFilters = 
        (!isDefaultDateFilter(dateFilter) && dateFilter) || 
        (tagFilter && tagFilter.length > 0);
      
      if (hasActiveFilters) {
        setVenueFilterOpen(true);
      }
    }
  }, [event?.type, dateFilter, tagFilter]);

  useEffect(() => {
    if (venueSearchOpen) {
      requestAnimationFrame(() => searchInputRef.current?.focus());
    }
  }, [venueSearchOpen]);

  useEffect(() => {
    
    // Always set event when data changes, regardless of current state
    if (data) {
      setEvent(data);
    } else {
      setEvent(null);
    }
    
    // If it's a different event then reset detail-only UI state.
    if (event?._id !== data?._id) {
      setVenueFilterOpen(false);
      setShowFullDescription(shouldExpandDescriptionByDefault(data));
      setDetailMediaPage(0);
    }
  }, [data, event?._id]); // Added event?._id to dependencies


  // ANALYTICS TRACKING MOVED TO EventDetailsProvider
  // This ensures single source of truth and prevents duplicate tracking
  // The provider tracks selectedEvent and selectedSubEvent changes

// Helper function to convert hex to rgba
const hexToRgba = (hex, alpha) => {
  if (!hex) return `rgba(255, 255, 255, ${alpha})`;
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

// Memoize dynamic gradient creation to prevent recalculation on every render
const createDynamicGradient = useCallback((baseColor) => {
  if (!baseColor) {
    // Elegant dark gradient for venues or events without category
    return `
      radial-gradient(circle at 25% 25%, rgba(60, 60, 60, 0.8) 0%, transparent 60%),
      radial-gradient(circle at 75% 75%, rgba(75, 75, 75, 0.6) 0%, transparent 60%),
      radial-gradient(circle at 50% 10%, rgba(50, 50, 50, 0.4) 0%, transparent 50%),
      linear-gradient(135deg, #404040 0%, #2a2a2a 100%)
    `;
  }
  
  // Create bubbly gradient that complements the category color
  return `
    radial-gradient(circle at 20% 30%, ${hexToRgba(baseColor, 0.9)} 0%, transparent 60%),
    radial-gradient(circle at 80% 20%, ${hexToRgba(baseColor, 0.6)} 0%, transparent 50%),
    radial-gradient(circle at 40% 70%, ${hexToRgba(baseColor, 0.45)} 0%, transparent 55%),
    radial-gradient(circle at 70% 80%, ${hexToRgba(baseColor, 0.3)} 0%, transparent 45%),
    linear-gradient(135deg, #404040 0%, #2a2a2a 100%)
  `;
}, []);


  const toggleEventLike = () => {
    //^ ANALYTICS: send like/unlike event to analytics
    // Check if event is currently liked BEFORE toggling
    const isCurrentlyLiked = event.likes?.includes(user?._id);
    const action = isCurrentlyLiked ? 'unliked' : 'liked';
    
    trackSessionEvent({
      action: `${event.type} ${action}`,
      category: event.type,
      label: `${event.type}_${action}`,
      [event.type]: event._id,
      value: {
        name: event.name,
        address: event.address,
        category: event.category, // Required for backend analytics categorization
      },
      timestamp: Date.now(),
    });
    
    likeEvent(event);

    axios
      .get(`/${event.type}s/like/${event._id}`)
      .then((res) => {
        if (res.data.error) {
          enqueueSnackbar(res.data.error, { variant: "error" });
          likeEvent(event);
        }
      })
      .catch((err) => {
        console.log(err);
        likeEvent(event);
      });
  };

  const reportEvent = async (report_reason, report_notes = "") => {
    reportOpen && setReportOpen(false);

    try {
      const res = await axios.post(`/user/report`, {
        type: event.type,
        event: event.type === "event" ? event : null,
        venue: event.type === "venue" ? event : null,
        report_reason: report_reason,
        report_message: (report_notes || "").trim(),
      });

      if (res.data.error) {
        enqueueSnackbar(res.data.error, { variant: "error" });
      } else {
        await modal(() => (
          <div className="flex flex-col items-center p-kit-32 text-center">
            <div className="text-kit-md font-['Primary-Medium'] text-[var(--inyc-primary-text-color)]">
              report submitted!
            </div>
            <div className="mt-kit-6 text-kit-base font-['Primary-Regular'] font-normal text-[var(--inyc-primary-text-color)]">
              thanks for helping improve in—yc
            </div>
          </div>
        ));
      }
    } catch (err) {
      console.log(err);
      enqueueSnackbar("failed to submit report. please try again.", { variant: "error" });
    }
  };

  const shareEvent = async () => {
    try {
    const isNative = Capacitor.isNativePlatform(); // detect if on mobile native
    const result = await modal(
      ({ proceed }) => {
        // const [load, setLoad] = useState(false);
        const [tab, setTab] = useState("image");
        const fullimageref = useRef(null);
        const imgref = useRef(null);
        const stickerRef = useRef(null);
        const qrcoderef = useRef(null);
        const [validImageUrl, setValidImageUrl] = useState(null);

        //#region handlers
        
        // Function to validate if an image URL is accessible
        const validateImageUrl = async (imageUrl) => {
          try {
            const response = await fetch(imageUrl, { method: "HEAD" });
            return response.status === 200 ? imageUrl : null;
          } catch (error) {
            return null;
          }
        };

        // Check image validity on component mount
        React.useEffect(() => {
          const checkImage = async () => {
            let imageUrl = null;
            
            if (event.images?.length > 0) {
              const raw = event.images[0];
              imageUrl = raw.startsWith('http') ? raw : `${backendUrl}/assets/${raw}`;
            } else if (event.venueImages?.length > 0) {
              const raw = event.venueImages[0];
              imageUrl = raw.startsWith('http') ? raw : `${backendUrl}/assets/${raw}`;
            }
            
            if (imageUrl) {
              const validUrl = await validateImageUrl(imageUrl);
              setValidImageUrl(validUrl);
            }
          };
          
          checkImage();
        }, []);


        // Image capture using modern-screenshot
        const getAssetFile = async (element, url) => {
          let data;
          if (url) {
            data = url;
          } else {
            try {
              // Get actual dimensions to avoid shrinking
              const rect = element.getBoundingClientRect();
              const computedStyle = window.getComputedStyle(element);
              const actualWidth = Math.max(element.scrollWidth, element.offsetWidth, rect.width);
              const actualHeight = Math.max(element.scrollHeight, element.offsetHeight, rect.height);
              
              // Use modern-screenshot for image capture
              data = await domToPng(element, {
                width: actualWidth,
                height: actualHeight,
                scale: window.devicePixelRatio || 2,
                backgroundColor: null,
                style: {
                  margin: '0',
                  border: '0',
                  borderRadius: computedStyle.borderRadius,
                  minWidth: 'unset',
                  maxWidth: 'unset',
                  width: `${actualWidth}px`,
                  height: `${actualHeight}px`
                }
              });
              
            } catch (error) {
              throw error;
            }
          }
          
          const filename = `${Date.now()}.png`;
          await Filesystem.writeFile({
            path: filename,
            data: data,
            directory: Directory.Cache,
          });
          const uriResult = await Filesystem.getUri({
            directory: Directory.Cache,
            path: filename,
          });
          return { url: uriResult.uri, data: data };
        };

        const updateShare = async () => {
          // updateShareEvent(event);
          //^ ANALYTICS: share event to analytics
          if (useAsAnalytics) {
            trackSessionEvent({
              action: `${event.type} shared`,
              category: event.type,
              label: `${event.type}_shared`,
              [event.type]: event._id,
              value: {
                name: event.name,
                address: event.address,
                category: event.category, // Required for backend analytics categorization
              },
              timestamp: Date.now(),
            });
          }
          axios
            .get(`/${event.type}s/share-count/${event._id}`)
            .then((res) => {
              if (res.data.error) {
                // updateShareEvent(event);
              }
            })
            .catch((err) => {
              // updateShareEvent(event);
            });
        };

        // Helper to convert a base64 data URL to a File object
        const dataURLtoFile = (dataurl, filename) => {
          const arr = dataurl.split(",");
          const mimeMatch = arr[0].match(/:(.*?);/);
          if (!mimeMatch) return null;
          const mime = mimeMatch[1];
          const bstr = atob(arr[1]);
          let n = bstr.length;
          const u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          return new File([u8arr], filename, { type: mime });
        };

        const shareQrCode = async () => {
          setTab("qr");
          // getAssetFile returns both the file URI and the base64 data URL.
          const { url: qrUri, data: qrData } = await getAssetFile(
            qrcoderef.current
          );
          console.log("qrUri", qrUri);

          // Instead of using dataURLtoFile, convert the QR code base64 string to a Blob then a File.
          let qrFile;
          try {
            const response = await fetch(qrData);
            const blob = await response.blob();
            qrFile = new File([blob], "qr.png", { type: blob.type });
          } catch (err) {
            console.error("Error converting QR data to file:", err);
          }

          try {
            // If we can share a file (native platforms or via navigator.canShare) then share the File.
            if (
              qrFile &&
              ((navigator.canShare &&
                navigator.canShare({ files: [qrFile] })) ||
                Capacitor.isNativePlatform())
            ) {
              await Share.share({
                files: [qrFile],
                title: "Check out this event on in—yc",
              });
            } else {
              // Fallback: share the URL instead (mostly for desktop browsers).
              await Share.share({
                url: qrUri,
                title: "Check out this event on in—yc",
              });
            }
            updateShare();
          } catch (error) {
            console.error("Error sharing QR code:", error);
            // Fallback share in case of an error.
            await Share.share({
              url: qrUri,
              title: "Check out this event on in—yc",
            });
            updateShare();
          }
        };

        const shareImage = async () => {
          const log = startLog({
            user: user,
            event: "share image",
          });
          try {
            setTab("image");
            log.log("tab set to image");
            const { url: uri, data: base64img } = await getAssetFile(
              fullimageref.current
            );
            log.log("using capacitor share");
            await Share.share({
              files: [uri],
              url: `https://app.inyc.us/#/?location=${event._id}`,
              title: "Check out this event on in—yc",
            });

            log.log("[Success] shared");
          } catch (error) {
            log.log("[Error] ", error);
            console.error(error);
          } finally {
            updateShare();
            log.display();
          }
        };

        const copyLink = async () => {
          setTab("image");
          const shareContent = `https://app.inyc.us/#/?location=${event._id}`;

          try {
            if (isNative) {
              await Clipboard.write({ string: shareContent });
            } else {
              await navigator.clipboard.writeText(shareContent);
            }
            enqueueSnackbar("link copied to clipboard.", {
              variant: "success",
            });
            updateShare();
          } catch (error) {
            console.error("Error copying share link:", error);
            enqueueSnackbar("error copying content to clipboard.", {
              variant: "error",
            });
          }
        };

        const shareLink = async () => {
          const shareContent = `https://app.inyc.us/#/?location=${event._id}`;
          try {
            if (isNative) {
              await Share.share({
                url: shareContent,
                title: "Check out this event on in—yc",
              });
            } else if (navigator.share) {
              await navigator.share({
                url: shareContent,
                title: "Check out this event on in—yc",
              });
            } else {
              await Share.share({
                url: shareContent,
                title: "Check out this event on in—yc",
              });
            }
            updateShare();
          } catch (error) {
            if (error?.name !== "AbortError") {
              console.error("Error sharing link:", error);
              enqueueSnackbar("unable to open share options.", {
                variant: "error",
              });
            }
          }
        };

        const shareInstagramStory = async () => {
          const log = startLog({
            user: user,
            event: "open instagram",
          });
          const result = await modal(
            ({ proceed }) => {
              return (
                <AppStatusScreen
                  title="share to instagram stories"
                  hideLogo
                  centerClassName="mt-kit-16"
                  body={
                    <>
                      <p>we've copied your event link for you</p>
                      <p>on instagram:</p>
                      <p>tap: “sticker” then “link”</p>
                      <p>paste the link, add custom text</p>
                    </>
                  }
                  actions={
                    <div className="flex w-full items-center justify-center gap-kit-8">
                      <KitButton fullWidth className="max-w-[9.4rem]" onClick={() => proceed(false)}>
                        cancel
                      </KitButton>
                      <KitButton variant="primary" fullWidth className="max-w-[9.4rem]" onClick={() => proceed(true)}>
                        share
                      </KitButton>
                    </div>
                  }
                />
              );
            },
            {
              raw: true,
              fullScreen: true,
            }
          );
          if (result) {
            try {
              try {
                const { url: stickerUri } = await getAssetFile(
                  stickerRef.current
                );
                const shareUrl = `https://app.inyc.us/#/?location=${event._id}`;
                // Pre-encode the hash portion to prevent Instagram from mangling it
                const encodedShareUrl = shareUrl.replace('#/', encodeURIComponent('#/'));

                await Clipboard.write({
                  string: encodedShareUrl,
                });
                await Instagram.shareToInstagramStory({
                  appID: FACEBOOK_APP_ID,
                  stickerImage: stickerUri,
                  shareUrl: encodedShareUrl,
                });
                log.log("opened instagram");
              } catch (err) {
                log.log("[Error] error opening instagram", JSON.stringify(err));
                log.log("[Error] ", err.message);
              }
            } catch (error) {
              log.log("[Error] ", error.message);
            } finally {
              log.display();
              updateShare();
            }
          }
        };



        //#endregion

        return (
          <div className="min-h-[100vh] flex flex-col justify-between items-center">
            <div className="flex w-full justify-center items-center flex-1">
              <Tabs
                staticHeight
                contentWrapperClass="items-center"
                className="w-full"
                tabs={["image", "qr"]}
                hideTabs
                currentTab={tab}
                setCurrentTab={setTab}
              >
                <TabContent name="image">
                  <div
                    ref={fullimageref}
                    className="relative overflow-hidden h-[590px] flex items-center justify-center w-[350px] mx-auto mb-kit-16 rounded-kit-lg"
                  >
                    <div
                      ref={imgref}
                      className={`absolute top-0 left-0 w-full h-full `}
                      style={{
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundImage: createDynamicGradient(activeColor),
                      }}
                    ></div>
                    <div
                      ref={stickerRef}
                      className={`relative z-[1] text-start duration-300 p-kit-24 rounded-kit-xl min-w-[200px] max-w-[70%] border border-white/20`}
                      style={{
                        background: activeColor 
                          ? hexToRgba(activeColor, 0.7)  // Events: category color
                          : 'rgba(60, 60, 60, 0.8)',     // Venues: dark gray-ish
                        color: 'white',
                      }}
                    >
                      <div className="mb-kit-6">
                        {validImageUrl && (
                          <div className="mb-kit-16 rounded-kit-md overflow-hidden relative w-full h-[150px] border border-white/10">
                            <img
                              src={validImageUrl}
                              alt="event preview"
                              style={{
                                aspectRatio: "1/1",
                                width: "100%",
                                objectFit: "cover",
                                display: "block",
                              }}
                            />
                            <div 
                              className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"
                            ></div>
                          </div>
                        )}
                        {event.type === "event" && (
                          <div className="flex justify-between items-start">
                            {event.category && (
                              <div
                                className="text-white w-fit break-words text-kit-sm px-kit-12 py-kit-6 font-['Primary-Medium'] mb-kit-16 rounded-kit-sm border border-white/20"
                                style={{
                                  background: `rgba(255, 255, 255, 0.1)`, /* Solid color for Android performance */
                                  /* Removed backdrop-blur and box-shadow */
                                }}
                              >
                                {event.category?.toLowerCase()}
                              </div>
                            )}
                            {dateString && (
                              <div
                                className="text-white w-fit break-words text-kit-xs px-kit-12 py-kit-4 font-['Primary-Medium'] mb-kit-16 rounded-kit-sm border border-white/20"
                                style={{
                                  background: `rgba(255, 255, 255, 0.1)`, /* Solid color for Android performance */
                                  /* Removed backdrop-blur and box-shadow */
                                }}
                              >
                                {dateString}
                              </div>
                            )}
                          </div>
                        )}
                        <div className="text-white break-words text-kit-2xl leading-[2.1rem] font-['Primary-Bold'] mb-kit-6">
                          {event.name}
                        </div>
                        <div
                          style={{
                            color: "rgba(255, 255, 255,0.5)",
                          }}
                          className="text-kit-md font-['Primary-Regular']"
                        >
                          {eventLocationLabel}
                        </div>
                        {event.type === "event" && (
                          <>
                            <div className="flex mb-kit-10 justify-between items-center gap-kit-16 leading-[1rem]">
                              <div
                                style={{
                                  color: lightColor,
                                }}
                                className="font-['Primary-Regular'] text-kit-base"
                              >
                                {rruleString}
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                      {event.type === "event" && formattedTime && (
                        <div className="flex justify-end items-end mb-kit-8">
                          <div
                            className="text-white px-kit-12 font-bold w-fit rounded-kit-sm text-kit-2xs font-['Primary-Medium'] leading-[1rem] py-kit-6 whitespace-nowrap border border-white/20"
                            style={{
                              background: `rgba(255, 255, 255, 0.15)`, /* Solid color for Android performance */
                              /* Removed backdrop-blur and box-shadow */
                            }}
                          >
                            {formattedTime}
                          </div>
                        </div>
                      )}
                      <div className="gap-kit-6 flex items-center justify-start text-white">
                        <div className="text-kit-sm relative text-white font-['Primary-Regular']">
                          details on
                        </div>
                        <img
                          className="h-[18px]"
                          src={`${backendUrl}/icon_white_nobg.png`}
                        />
                      </div>
                    </div>
                  </div>
                </TabContent>
                <TabContent
                  name="qr"
                  className="flex items-center justify-center"
                >
                  <div
                    ref={qrcoderef}
                    className="rounded-[var(--inyc-input-border-radius)] overflow-hidden"
                  >
                    <React.Suspense fallback={<Loader />}>
                      <QRCode
                        qrStyle="fluid"
                        eyeRadius={10}
                        value={`https://app.inyc.us/#/?location=${event._id}`}
                        size={200}
                      />
                    </React.Suspense>
                  </div>
                </TabContent>
              </Tabs>
            </div>
            <div
              className={`relative duration-300 w-full md:w-fit md:min-w-[300px] pt-kit-32 pb-kit-64 px-kit-48 rounded-t-kit-2xl border-[1px] border-[--inyc-input-border-color] bg-[var(--inyc-primary)] shadow-md`}
            >
              <div className="flex flex-wrap justify-center items-stretch  gap-kit-8 mb-kit-16">
                {(availableApps?.native || navigator.share) && (
                  <ActionTile onClick={shareLink} icon={<IoIosLink />}>
                    share link
                  </ActionTile>
                )}
                {availableApps?.instagram && (
                  <ActionTile onClick={shareInstagramStory} icon={<FaInstagram />}>
                    post story
                  </ActionTile>
                )}
                {availableApps?.native && isNative && (
                  <ActionTile onClick={shareImage} icon={<TbPhotoShare />}>
                    share image
                  </ActionTile>
                )}
                <ActionTile onClick={copyLink} icon={<IoCopyOutline />}>
                    copy link
                  </ActionTile>
                <ActionTile onClick={() => setTab("qr")} icon={<MdQrCode2 />}>
                    QR code
                  </ActionTile>
                {availableApps?.native && isNative && (
                  <ActionTile onClick={shareQrCode} icon={<TbShare3 />}>
                    share QR code
                  </ActionTile>
                )}
              </div>
              <IconButton
                size="md"
                label="close"
                icon={<IoMdClose />}
                className="absolute top-[0.5rem] right-[1rem]"
                onClick={() => proceed(false)}
              />
            </div>
          </div>
        );
      },
      {
        raw: true,
        fullScreen: true,
      }
    );
    } catch (error) {
      console.error("Error opening event share options:", error);
      enqueueSnackbar("unable to open share options.", {
        variant: "error",
      });
    }
  };

  // Track debug events entering EventDetails component
  if (event) {
    trackTransformation("EventDetails", "COMPONENT_ENTRY", event);
  }

  // PERFORMANCE: Memoize expensive date formatting to avoid recalculation on every render
  const { formattedDate, formattedTime, rruleString, dateString } = useMemo(() => 
    formatDateTime(event?.nextOccurence || event?.date, event?.timezone, {
      rrule: event?.rrule,
      recurring: event?.recurring,
      recurringEnd: event?.recurringEnd,
      frequency: event?.frequency,
    }, event),
    [
      event?.nextOccurence?.start,
      event?.nextOccurence?.end,
      event?.date?.start,
      event?.date?.end,
      event?.timezone?.[0],
      event?.rrule,
      event?.recurring,
      event?.recurringEnd,
      event?.frequency,
    ]
  );

  const toggleFollow = async () => {
    toggleFollowUser(event.account_id?._id);

    axios
      .get(`/user/follow/${event.account_id?._id}`)
      .then((res) => {
        if (res.data.error) {
          enqueueSnackbar(res.data.error, { variant: "error" });

          toggleFollowUser(event.account_id?._id);
        }
      })
      .catch((err) => {
        console.log(err);

        toggleFollowUser(event.account_id?._id);
      });
  };

  const toggleFollowArtist = async (artistId) => {
    if (!artistId) return;
    
    toggleFollowUser(artistId);

    axios
      .get(`/user/follow/${artistId}`)
      .then((res) => {
        if (res.data.error) {
          enqueueSnackbar(res.data.error, { variant: "error" });

          toggleFollowUser(artistId);
        }
      })
      .catch((err) => {
        console.log(err);

        toggleFollowUser(artistId);
      });
  };

  const addToCalendar = async () => {
    const perm = await CapacitorCalendar.checkAllPermissions();
    if (perm.writeCalendar !== "granted" || perm.readCalendar !== "granted") {
      const req = await CapacitorCalendar.requestAllPermissions();
      // console.log("CapacitorCalendar.requestAllPermissions ");
      if (req.writeCalendar !== "granted" || req.readCalendar !== "granted") {
        // console.log("permission denied");
        enqueueSnackbar("permission denied", { variant: "error" });
        return;
      }
      // console.log(JSON.stringify(req, null, 2));
    }

    const dates = {
      startDate: new Date((event.nextOccurence || event.date)?.start).getTime(),
      endDate: new Date((event.nextOccurence || event.date)?.end).getTime(),
    };
    // console.log(JSON.stringify(dates, null, 2));
    // check if event already exists
    const cal = await CapacitorCalendar.listEventsInRange({
      startDate: new Date(dates.startDate).setDate(
        new Date(dates.startDate).getDate() - 1
      ),
      endDate: new Date(dates.endDate).setDate(
        new Date(dates.endDate).getDate() + 1
      ),
    });

    if (cal.result && cal.result?.length > 0) {
      for (let i = 0; i < cal.result.length; i++) {
        if (
          cal.result[i].title === event.name &&
          cal.result[i].startDate ===
            new Date((event.nextOccurence || event.date)?.start).getTime() &&
          cal.result[i].endDate ===
            new Date((event.nextOccurence || event.date)?.end).getTime()
        ) {
          enqueueSnackbar("event already exists in calendar", {
            variant: "error",
          });
          return;
        }
      }
    }

    // console.log("creating event");
    await CapacitorCalendar.createEvent({
      title: event.name,
      location: event.address,
      startDate: dates.startDate,
      endDate: dates.endDate,
      notes: event.description,
      url: `https://app.inyc.us/#/?location=${event._id}`,
    })
      .then((res) => {
        // console.log("Event added to calendar", JSON.stringify(res, null, 2));
        
        //^ ANALYTICS: track add to calendar action
        if (useAsAnalytics) {
          trackSessionEvent({
            action: `${event.type} added to calendar`,
            category: event.type,
            label: `${event.type}_calendar`,
            [event.type]: event._id,
            value: {
              name: event.name,
              address: event.address,
              category: event.category, // Required for backend analytics categorization
              date: event.nextOccurence || event.date,
            },
            timestamp: Date.now(),
          });
        }
        
        enqueueSnackbar("event added to calendar", {
          variant: "success",
          persist: false,
          content: (key) => (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "var(--inyc-success-strong)",
                color: "white",
                fontFamily: "Primary-Regular",
                padding: "var(--inyc-space-10)",
                fontSize: "var(--inyc-text-md)",
                borderRadius: "var(--inyc-radius-xs)",
              }}
            >
              <LuCalendarPlus
                style={{
                  marginRight: "var(--inyc-space-10)",
                  marginLeft: "var(--inyc-space-10)",
                  fontSize: "var(--inyc-text-md)",
                }}
              />
              event added to calendar
            </div>
          ),
        });
      })
      .catch((error) => {
        console.error(
          "Error adding event to calendar",
          JSON.stringify(error, null, 2)
        );
        enqueueSnackbar("error adding event to calendar", { variant: "error" });
      });

    // console.log("finished creating event");
  };

  // console.log("EventDetails event : ", event);
  // Now compute filtersActive; if dateFilter equals the default, ignore it.
  // Memoize filters active check to prevent re-calculation on every render
  const filtersActive = useMemo(
    () =>
      (queryFilter && queryFilter !== "") ||
      (!isDefaultDateFilter(dateFilter) && dateFilter) ||
      activeCategories.length < categories.length,
    [queryFilter, dateFilter, activeCategories.length, categories.length]
  );

  // Memoize expensive array lookups to prevent re-running on every render
  const likedEvent = useMemo(
    () => likedEvents?.find((e) => e._id === event?._id) || event,
    [likedEvents, event?._id, event]
  );

  const styleCategory = useMemo(
    () => categories.find((cat) => cat.id === event?.category),
    [categories, event?.category]
  );
  // Only apply category-based colors for events, not venues
  const activeColor = event?.type === "event" ? styleCategory?.activeColor : undefined;
  const secondaryColor = event?.type === "event" ? styleCategory?.secondaryColor : undefined;
  const lightColor = event?.type === "event" ? styleCategory?.lightColor : undefined;

  // Category colors are now handled via CSS classes for performance
  // No need to calculate inline - everything is pre-computed in categoryStyles.js

  // Memoize venue name computations to avoid re-calculating on every render
  const venueName = useMemo(
    () => 
      selectedSubEvent?.venue && selectedSubEvent?.venue === selectedEvent?._id
        ? selectedEvent?.name
        : event?.venueDetails?._id
        ? event?.venueDetails?.name
        : event?.venue?._id
        ? event?.venue?.name
        : null,
    [selectedSubEvent?.venue, selectedEvent?._id, selectedEvent?.name, event?.venueDetails?._id, event?.venueDetails?.name, event?.venue?._id, event?.venue?.name]
  );

  const currentVenueName = useMemo(
    () =>
      selectedSubEvent?.venue && selectedSubEvent?.venue === selectedEvent?._id
        ? selectedEvent?.name
        : event?.venueDetails?._id
        ? event?.venueDetails?.name
        : event?.venue?._id
        ? event?.venue?.name
        : event?.type === "venue" 
        ? event?.name
        : null,
    [selectedSubEvent?.venue, selectedEvent?._id, selectedEvent?.name, event?.venueDetails?._id, event?.venueDetails?.name, event?.venue?._id, event?.venue?.name, event?.type, event?.name]
  );

  const googleLocationName = useMemo(() => {
    if (event?.type !== "event" || venueName) return "";

    const structuredName = event?.addressFields?.venueName?.trim();
    if (structuredName) return structuredName;

    return getLegacyGoogleLocationName(event?.address || "");
  }, [event?.type, event?.addressFields?.venueName, event?.address, venueName]);

  const googleLocationAddress = useMemo(() => {
    if (!googleLocationName) return event?.address || "";
    return stripAddressPrefix(event?.address || "", googleLocationName);
  }, [event?.address, googleLocationName]);

  const eventLocationLabel = useMemo(() => {
    if (event?.type === "event" && venueName) return venueName;
    if (event?.type === "event" && googleLocationName) return googleLocationName;
    return event?.address?.toLowerCase();
  }, [event?.type, event?.address, venueName, googleLocationName]);

  const { unnamedSocials, namedSocials } = useMemo(
    () => splitIconAndNamedSocials(event?.socials),
    [event?.socials]
  );

  // Memoize expensive eventItems computation to prevent re-calculation on every render
  const eventItems = useMemo(() => {
    if (!event || event?.type !== "venue") return null;
    
    const filteredEventsWithFlag = filteredEvents?.map((e) => {
      e._filterEvent = true;
      return e;
    }) || [];
    
    const remainingEvents = event?.events?.filter(
      (l) => !filteredEvents?.some((fl) => fl._id === l._id)
    ) || [];
    
    return [...filteredEventsWithFlag, ...remainingEvents];
  }, [event?.type, event?.events, filteredEvents]);

  // Removed debug logging for eventItems, filtersActive, venueName

  // Optimized: Only recalculate when relevant properties change, not entire event object
  const eventCategoryClass = useMemo(
    () => getEventCategoryClass(event), 
    [event?._id, event?.type, event?.category]
  );

  const closeBtnRef = useRef(null);
  const [closeBtnScrolled, setCloseBtnScrolled] = useState(false);

  useEffect(() => {
    if (!Close) {
      setCloseBtnScrolled(false);
      return;
    }

    const button = closeBtnRef.current;
    let node = parentRef?.current || button?.parentElement;
    while (node && node !== document.body) {
      const overflowY = window.getComputedStyle(node).overflowY;
      if (/(auto|scroll|overlay)/.test(overflowY)) break;
      node = node.parentElement;
    }
    const scrollParent = node || document.scrollingElement;
    if (!scrollParent) return;

    const onScroll = () => {
      setCloseBtnScrolled(scrollParent.scrollTop > 8);
    };
    onScroll();
    scrollParent.addEventListener("scroll", onScroll, { passive: true });
    return () => scrollParent.removeEventListener("scroll", onScroll);
  }, [Close, parentRef, event?._id]);

  return (
    <>
      {event ? (
        <div
          className={`event-detail-container pb-kit-48 ${className} ${eventCategoryClass}`}
          style={{
            background: "var(--inyc-primary)",
            borderRadius: sheetLayout ? "1.5rem 1.5rem 0 0" : undefined,
            "--inyc-details-secondary-color": "var(--inyc-primary-text-color-light)",
            "--inyc-details-btn-bg": "var(--inyc-primary-button)",
            "--inyc-details-border-color": "var(--inyc-input-border-color)",
            "--inyc-details-light-color": "var(--inyc-primary-text-color)",
            "--inyc-details-text-color": "var(--inyc-primary-text-color)",
            paddingBottom: "calc(var(--inyc-bottom-space, 0) + 6rem)",
          }}
          onTouchStart={event.type === "venue" ? handleDetailPagerTouchStart : undefined}
          onTouchEnd={event.type === "venue" ? handleDetailPagerTouchEnd : undefined}
        >
          {previewOnly && (
            <div className="event-preview-heading px-kit-24 mb-kit-10">
              <div className="inyc-label !mb-0">
                event preview
              </div>
              <div className="inyc-help mt-kit-2">
                this is how your event will appear to in—yc users
              </div>
            </div>
          )}
          {Close && (
            <IconButton
              ref={closeBtnRef}
              size="md"
              label="close"
              icon={<IoMdClose size={24} />}
              className={`event-details-close-btn${closeBtnScrolled ? " is-scrolled" : ""}`}
              onClick={Close}
            />
          )}
          <div className="px-kit-24">
            {previewOnly && (
              <div className="event-preview-title-divider" />
            )}
            <div className={`${Close ? "mt-0" : "mt-kit-12"} mb-kit-8`}>
              <div
                className="inyc-display min-w-0 w-full max-w-full break-normal"
              >
                {event.name}
              </div>
            </div>
            {/* tags */}
            <div className="flex items-end max-w-full flex-wrap justify-start gap-kit-8 mb-kit-16">
              {event?.category && event.type === "event" && (
                <Badge size="xl" style={activeColor ? { color: activeColor } : undefined}>
                  {event?.category}
                </Badge>
              )}
              {event?.type === "venue" && event?.venueType && (
                  <Badge size="sm">{event?.venueType?.toLowerCase()}</Badge>
              )}
              {/* Venue attributes (food, alcohol, outdoor) */}
              {event?.food && (
                      <Badge size="sm" className="relative icon" icon={<MdRestaurant size={13} />}>
                        <span className="tooltip">food</span>
                      </Badge>
                    )}
                    {event?.alcohol && (
                      <Badge size="sm" className="relative icon" icon={<MdLocalBar size={13} />}>
                        <span className="tooltip">alcohol</span>
                      </Badge>
                    )}
                    {event?.outdoor && (
                      <Badge size="sm" className="relative icon" icon={<MdWbSunny size={13} />}>
                        <span className="tooltip text-center">outdoor space</span>
                      </Badge>
                    )}
                    <div
                      className={`flex flex-wrap gap-kit-4 items-center ${event?.type === "venue" ? "ml-auto" : ""}`}
                    >
              {event?.tags?.length > 0 &&
                [...new Set(event?.tags.filter(tag => tag && tag.trim() !== ''))]?.map((tag, i) => (
                  <Badge key={i}>
                    {knownServices[tag?.toLowerCase()]?.icon ? (
                      <>
                        <span className="w-[16px] h-[16px] rounded-kit-full flex items-center justify-center overflow-hidden">
                          {loadIcon(knownServices[tag?.toLowerCase()]?.icon, {
                            size: 15,
                          })}
                        </span>
                        {knownServices[tag?.toLowerCase()]?.name}
                      </>
                    ) : (
                      tag?.toLowerCase()
                    )}
                  </Badge>
                ))}
                    </div>
            </div>
            {/* event address */}
            <div
              className={`event-detail-address`}
              style={{
                color: "var(--inyc-details-light-color)",
                marginBottom: "calc(0.5rem + 5px)",
              }}
            >
              {event.type === "event" && venueName && (
                <>
                  <div className="flex items-start justify-between gap-kit-16">
                    <span
                      className={`${previewOnly ? "cursor-default" : "cursor-pointer hover-hover:opacity-70 active:opacity-70"} duration-300 font-['Primary-Medium']`}
                      onClick={previewOnly ? undefined : () => setSelectedSubEvent(null)}
                      style={{
                        color: "var(--inyc-details-light-color)",
                      }}
                    >
                      <div className="flex items-start gap-kit-8">
                        <div className="inline-block font-['Primary-Medium'] w-[1.2rem] h-[1.5rem]">
                          <LocationSVG
                            color="var(--inyc-details-light-color)"
                          />
                        </div>
                        <span className="font-['Primary-Medium']">
                          {venueName}
                        </span>
                      </div>
                    </span>
                    {/* distance next to venue name - only for events */}
                    {selectedEvent?.location?.coordinates && (
                      <span 
                        className="text-kit-xs font-['Primary-Regular'] text-nowrap mt-kit-4"
                        style={{
                          color: "var(--inyc-details-light-color)",
                          opacity: 0.7,
                        }}
                      >
                        {
                          (distance(
                            userLocation?.lat,
                            userLocation?.lng,
                            selectedEvent?.location?.coordinates[1],
                            selectedEvent?.location?.coordinates[0]
                          )?.toFixed(2)) ||
                          0
                        } mi
                      </span>
                    )}
                  </div>
                </>
              )}
              {event.type === "event" && !venueName && googleLocationName && (
                <div className="flex items-start justify-between gap-kit-16">
                  <button
                    type="button"
                    className={`${previewOnly ? "cursor-default" : "cursor-pointer hover-hover:opacity-70 active:opacity-70"} duration-300 text-left font-['Primary-Medium']`}
                    onClick={previewOnly ? undefined : () => onGetDirections(event)}
                    style={{
                      color: "var(--inyc-details-light-color)",
                    }}
                  >
                    <div className="flex items-start gap-kit-8">
                      <div className="flex min-w-0 flex-col">
                        <span className="font-['Primary-Medium']">
                          {googleLocationName}
                        </span>
                        {googleLocationAddress && (
                          <span className="mt-kit-2 text-kit-sm font-['Primary-Regular'] opacity-70">
                            {googleLocationAddress.toLowerCase()}
                          </span>
                        )}
                      </div>
                      <div className="mt-kit-2 inline-flex h-[1.15rem] w-[1.15rem] shrink-0 items-center justify-center rounded-kit-full bg-[var(--inyc-primary-light)]">
                        <FaGoogle
                          size={11}
                          color="var(--inyc-details-light-color)"
                        />
                      </div>
                    </div>
                  </button>
                  {selectedEvent?.location?.coordinates && (
                    <span
                      className="text-kit-xs font-['Primary-Regular'] text-nowrap mt-kit-4"
                      style={{
                        color: "var(--inyc-details-light-color)",
                        opacity: 0.7,
                      }}
                    >
                      {
                        (distance(
                          userLocation?.lat,
                          userLocation?.lng,
                          selectedEvent?.location?.coordinates[1],
                          selectedEvent?.location?.coordinates[0]
                        )?.toFixed(2)) ||
                        0
                      } mi
                    </span>
                  )}
                </div>
              )}
              {event.type === "venue" && !venueName && !googleLocationName && event.address && (
                <div className="flex items-center justify-between gap-kit-16">
                  <span>
                    {event.address
                      ?.toLowerCase()
                      .replace(currentVenueName?.toLowerCase() + ",", "")}
                  </span>
                  <span
                    className="text-kit-xs font-['Primary-Regular'] text-nowrap"
                    style={{
                      color: "var(--inyc-details-light-color)",
                      opacity: 0.7,
                    }}
                  >
                    {(selectedEvent?.location?.coordinates &&
                      distance(
                        userLocation?.lat,
                        userLocation?.lng,
                        selectedEvent?.location?.coordinates[1],
                        selectedEvent?.location?.coordinates[0]
                      )?.toFixed(2)) ||
                      0}{" "}
                    mi
                  </span>
                </div>
              )}
              {event.type !== "venue" && !venueName && !googleLocationName &&
                event.address
                  ?.toLowerCase()
                  .replace(currentVenueName?.toLowerCase() + ",", "")}
            </div>
            {/* date and time bubbles */}
            <div className="mb-kit-16">
              {event.type === "event" && (
                <div className="flex justify-between items-center gap-kit-8 mb-kit-6 flex-wrap">
                  <div className="flex items-end gap-kit-8 min-w-0 flex-wrap">
                    {dateString && <Badge strong>{dateString}</Badge>}
                    {rruleString && (
                      <div className="inyc-help is-sm">
                        {rruleString}
                      </div>
                    )}
                  </div>
                  {formattedTime && <Badge strong key={event?._id}>{formattedTime}</Badge>}
                </div>
              )}
            </div>
            {/* buttons */}
            {(!previewOnly || unnamedSocials.length > 0 || namedSocials.length > 0) && (
              <div className="event-details-action-socials-block w-full max-w-full">
              <div className="event-details-action-socials-row mb-0 gap-kit-16 w-full max-w-full">
                {!previewOnly && (
                <>
                <IconButton
                  variant="secondary"
                  shape="box"
                  size="md"
                  className="event-details-action-btn"
                  label={likedEvent.likes?.includes(user?._id) ? "unlike" : "like"}
                  icon={likedEvent.likes?.includes(user?._id) ? <AiFillHeart color={activeColor} size={20} /> : <AiOutlineHeart size={20} />}
                  onClick={toggleEventLike}
                />
                <IconButton
                  variant="secondary"
                  shape="box"
                  size="md"
                  className="event-details-action-btn"
                  label="directions"
                  icon={<LocationSVG color="currentColor" outline className="!w-[20px] !h-[20px]" />}
                  onClick={() => onGetDirections(event)}
                />
                <TicketButton 
                  tickets={getDisplayTickets(event)}
                  event={event}
                  trackSessionEvent={trackSessionEvent}
                  ensureValidUrl={ensureValidUrl}
                />
                <IconButton
                  variant="secondary"
                  shape="box"
                  size="md"
                  className="event-details-action-btn"
                  label="share"
                  icon={<IoShareOutline size={20} />}
                  onClick={shareEvent}
                />
                {Capacitor.isNativePlatform() && event.type === "event" && (
                  <IconButton
                    variant="secondary"
                    shape="box"
                    size="md"
                    className="event-details-action-btn"
                    label="add to calendar"
                    icon={<LuCalendarPlus size={20} />}
                    onClick={addToCalendar}
                  />
                )}
                <div className="relative z-[100]" ref={reportRef}>
                  <IconButton
                    variant="secondary"
                    shape="box"
                    size="md"
                    className="event-details-action-btn"
                    label="report"
                    icon={<RiFlag2Line size={20} />}
                    onClick={() => setReportOpen(!reportOpen)}
                  />
                  <EventReportDropDown
                    open={reportOpen}
                    onReport={reportEvent}
                    type={event.type}
                  />
                </div>
                </>
                )}
                {unnamedSocials.length > 0 && (
                  <div className="event-details-socials-cluster event-details-socials-view">
                    <SocialsView
                      socials={unnamedSocials}
                      eventType={event.type}
                      variant="icons"
                    />
                  </div>
                )}
              </div>
              {namedSocials.length > 0 && (
                <div className="event-details-named-socials">
                  {namedSocials.map((social, i) => (
                    <SocialButton
                      key={`named-${social.link || i}`}
                      social={social}
                      eventType={event.type}
                      labelMode="row"
                    />
                  ))}
                </div>
              )}
              </div>
            )}
            
            {(event.type === "event" || event.socials?.length > 0) && (
              <div className="inyc-divider-fade is-both event-details-socials-dots-divider" aria-hidden="true" />
            )}

            <div
              className={`grid grid-rows-[1fr] duration-200 ${event.type === "venue" ? "overflow-visible" : "overflow-hidden"}`}
            >
              <div className={`event-details-page-shell min-h-0 ${isVenueEventsView ? "event-details-page-shell--events" : ""}`}>
                {showDetailPageDots && (
                  <>
                    <div
                      className={`event-details-page-dots-frame${detailPages.length <= 1 ? " event-details-page-dots-frame--solo" : ""}`}
                    >
                      <div
                        className="event-details-page-dots"
                        aria-label="details pages"
                      >
                        {visibleDetailPages.map((page) => {
                          const index = detailPages.findIndex((detailPage) => detailPage.id === page.id);
                          const isSearch = page.id === "search";
                          const isActive = detailMediaPage === index;
                          return (
                          <button
                            key={page.id}
                            type="button"
                            aria-label={
                              isSearch
                                ? venueSearchOpen
                                  ? "hide event search"
                                  : "search events at this venue"
                                : `show ${page.label}`
                            }
                            aria-pressed={isActive}
                            aria-expanded={isSearch ? venueSearchOpen : undefined}
                            className={`event-details-page-dot${isSearch ? " venue-events-search-tab-icon" : ""}${isActive ? " active" : ""}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (isSearch && venueSearchOpen) {
                                const eventsIndex = detailPages.findIndex((detailPage) => detailPage.id === "events");
                                setDetailMediaPage(eventsIndex >= 0 ? eventsIndex : 0);
                                searchInputRef.current?.blur();
                                return;
                              }
                              setDetailMediaPage(index);
                            }}
                        >
                          {page.label}
                        </button>
                          );
                        })}
                      </div>
                    </div>
                  </>
                )}
                {showMediaEmbeds && (
                  <div className="event-details-socials-view">
                    <SocialsView
                      socials={event.socials}
                      eventType={event.type}
                      variant="media"
                    />
                  </div>
                )}
                <div
                  className="event-details-paged-content"
                  onTouchStart={event.type === "venue" ? undefined : handleDetailPagerTouchStart}
                  onTouchEnd={event.type === "venue" ? undefined : handleDetailPagerTouchEnd}
                >
                  <div className={activeDetailPage === "details" ? "" : "hidden"}>
                    <div
                      className={`event-detail-description text-[--inyc-details-text-color] ${
                        showMediaEmbeds
                          ? "mt-[var(--inyc-details-stack-gap)]"
                          : showDetailPageDots
                            ? "mt-kit-8"
                            : "mt-kit-16"
                      }`}
                      style={{
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {showFullDescription ? (
                        sanitizedDescription
                      ) : (
                        <div className="text-[--inyc-details-text-color]">
                          {sanitizedDescription?.slice(0, characterLimit)}
                          {event.description?.length > characterLimit ? "..." : ""}
                        </div>
                      )}
                    </div>
                    {hasLongDescription && (
                      <div className="flex justify-end mt-kit-6 mb-[var(--inyc-details-stack-gap)]">
                        <KitButton
                          variant="tertiary"
                          size="sm"
                          aria-expanded={showFullDescription}
                          onClick={() => setShowFullDescription((isExpanded) => !isExpanded)}
                        >
                          {showFullDescription ? "show less" : "show more"}
                        </KitButton>
                      </div>
                    )}
                  </div>
                  {hasDetailImages && (
                    <div className={activeDetailPage === "photos" ? "" : "hidden"}>
                      <ImageSlider
                        className={`event-details-media-slider overflow-hidden mb-kit-16 rounded-kit-xs mt-kit-8${showMediaEmbeds ? " is-after-media" : ""}`}
                        images={detailImages}
                      />
                    </div>
                  )}
                </div>

                {/* Performer Slots Section */}
                {event.performerSlots && event.performerSlots.length > 0 && (
                  <div className="mb-kit-32">
                    <div className="inyc-label is-sm">lineup</div>
                    <div className="performer-slots-list">
                      {event.performerSlots.map((slot) => {
                        const occurrenceStart = event?.date?.start;
                        const timeStr =
                          slot.start && occurrenceStart
                            ? formatSlotOccurrenceTimeRange(
                                slot,
                                occurrenceStart,
                                event,
                                "hh:mm a"
                              )
                            : null;
                        // only treat as populated if it's a real object with an _id
                        const artist = slot.filledBy && typeof slot.filledBy === "object" && slot.filledBy._id
                          ? slot.filledBy
                          : null;
                        const artistName = artist
                          ? (artist.businessName ||
                              (artist.firstName && artist.lastName
                                ? `${artist.firstName} ${artist.lastName}`
                                : artist.username || artist.name || null))
                          : null;
                        return (
                          <div key={slot._id} className="performer-slot-row">
                            <div className="performer-slot-info">
                              <div className="performer-slot-title">{slot.title}</div>
                              {timeStr && <div className="performer-slot-time">{timeStr}</div>}
                            </div>
                            {artist && artistName ? (
                              <div
                                className="performer-slot-artist"
                                onClick={previewOnly ? undefined : () => selectAccount(artist)}
                                style={{ cursor: previewOnly ? "default" : "pointer" }}
                              >
                                <div className="performer-slot-avatar">
                                  {artist.profilePicture ? (
                                    <img src={artist.profilePicture} alt={artistName} />
                                  ) : (
                                    <FaUser size={10} color="var(--inyc-primary-color)" />
                                  )}
                                </div>
                                <div className="performer-slot-artist-name">{artistName}</div>
                              </div>
                            ) : (
                              <div className="performer-slot-open">open</div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* Linked Artists Section */}
                {event.linked_artists && event.linked_artists.length > 0 && (
                  <div className="mb-kit-32">
                    <div className="inyc-label is-sm">featuring</div>
                    <div className="linked-artists-grid">
                      {event.linked_artists
                        .filter(artist => artist && artist._id) // Skip null/undefined/deleted accounts
                        .map((artist) => (
                          <div key={artist._id} className="inyc-card is-sm poster-info-card">
                            <div 
                              className="poster-info-clickable"
                              onClick={previewOnly ? undefined : () => selectAccount(artist)}
                            >
                              <div className="poster-avatar">
                                {artist.profilePicture ? (
                                  <img
                                    src={artist.profilePicture}
                                    alt={artist.businessName || `${artist.firstName} ${artist.lastName}`}
                                    className="poster-avatar-image"
                                  />
                                ) : (
                                  <FaUser size={14} color="var(--inyc-primary-color)" />
                                )}
                              </div>
                              <div className="poster-details">
                                <div className="poster-name">
                                  {artist.businessName || 
                                   (artist.firstName && artist.lastName 
                                     ? `${artist.firstName} ${artist.lastName}` 
                                     : artist.username || 'unknown artist')
                                  }
                                </div>
                                {artist.accountType && (
                                  <span className="inyc-badge is-sm">
                                    {artist.accountType === "artist" ? "artist" : 
                                     artist.accountType === "business" ? "business" : "user"}
                                  </span>
                                )}
                              </div>
                            </div>
                            {!previewOnly && (
                              <IconButton
                                label={user?.following?.includes(artist._id) ? "unwatch" : "watch"}
                                icon={user?.following?.includes(artist._id) ? <FaEye /> : <FaRegEye />}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleFollowArtist(artist._id);
                                }}
                              />
                            )}
                          </div>
                        ))
                      }
                    </div>
                  </div>
                )}

                {/* //! rest */}
                {/* venue links */}
                {/* {event.type === "venue" && (
                  <>
                    <div>
                      {event.website && (
                        <a
                          target="_blank"
                          href={ensureValidUrl(event.website)}
                          className="event-detail-link"
                        >
                          website
                        </a>
                      )}
                      {event.media && // if media contains ' , ' then split it into an array and map over it
                        event.media.split(" , ").map((media, i) => (
                          <React.Fragment key={i}>
                            {media && (
                              <a
                                target="_blank"
                                href={ensureValidUrl(media)}
                                className="event-detail-link"
                              >
                                {extractWebsiteName(media)}
                              </a>
                            )}
                          </React.Fragment>
                        ))}
                    </div>
                  </>
                )} */}
                {/* event links */}
                {event.type === "event" && (
                  <div>
                    {event.paytheartist_link && (
                      <a
                        target="_blank"
                        href={ensureValidUrl(event.paytheartist_link)}
                        className="event-detail-link"
                      >
                        pay the artist
                      </a>
                    )}
                  </div>
                )}
                <div className="mb-[var(--inyc-details-stack-gap)]"></div>
                {/* venue emeneties */}
                {/* {event.alcohol && (
                  <div className="event-detail-amenity">
                    -this {event.type} has{" "}
                    <span
                      style={{
                        fontFamily: "Primary-Regular",
                        color: "var(--inyc-details-light-color)",
                      }}
                    >
                      alcohol
                    </span>
                  </div>
                )}
                {event.food && (
                  <div className="event-detail-amenity">
                    -this {event.type} has{" "}
                    <span
                      style={{
                        fontFamily: "Primary-Regular",
                        color: "var(--inyc-details-light-color)",
                      }}
                    >
                      food
                    </span>
                  </div>
                )}
                {event.outdoor && (
                  <div className="event-detail-amenity">
                    -this {event.type} has{" "}
                    <span
                      style={{
                        fontFamily: "Primary-Regular",
                        color: "var(--inyc-details-light-color)",
                      }}
                    >
                      outdoor space
                    </span>
                  </div>
                )} */}
                {(() => {
                  if (getDisplayTickets(event).length > 0) return null;

                  // Get ticket price from new tickets array or legacy ticket_price field
                  let ticketPriceDisplay = null;
                  
                  // Helper to format price based on priceType
                  const formatTicketPrice = (ticket) => {
                    const priceType = ticket.priceType || 'priced_at';
                    const price = ticket.price && ticket.price !== "$" ? ticket.price : "";
                    const priceMax = ticket.priceMax && ticket.priceMax !== "$" ? ticket.priceMax : "";
                    
                    switch (priceType) {
                      case 'starting_at':
                        return price ? `Starting at ${price.includes("$") ? price : "$" + price}` : null;
                      case 'donation':
                        return price ? (price.includes("$") ? price : "$" + price) : 'Donation / Pay what you can';
                      case 'rsvp':
                        return price ? (price.includes("$") ? price : "$" + price) : 'RSVP';
                      case 'door':
                        return price ? `${price.includes("$") ? price : "$" + price} at the door` : 'At the door';
                      case 'range':
                        if (price && priceMax) {
                          const p1 = price.includes("$") ? price : "$" + price;
                          const p2 = priceMax.includes("$") ? priceMax : "$" + priceMax;
                          return `${p1} - ${p2}`;
                        } else if (price) {
                          return price.includes("$") ? price : "$" + price;
                        }
                        return null;
                      case 'priced_at':
                      default:
                        return price ? (price.includes("$") ? price : "$" + price) : null;
                    }
                  };
                  
                  if (event.tickets && event.tickets.length > 0) {
                    if (event.tickets.length === 1) {
                      ticketPriceDisplay = formatTicketPrice(event.tickets[0]);
                    } else {
                      // Multiple tiers - show summary based on types
                      const hasDonation = event.tickets.some(t => t.priceType === 'donation');
                      const prices = event.tickets
                        .map(t => {
                          const price = t.price && t.price !== "$" ? t.price : null;
                          const priceMax = t.priceMax && t.priceMax !== "$" ? t.priceMax : null;
                          const numMin = price ? parseFloat(price.replace(/[^0-9.]/g, '')) : null;
                          const numMax = priceMax ? parseFloat(priceMax.replace(/[^0-9.]/g, '')) : null;
                          return { min: numMin, max: numMax || numMin };
                        })
                        .filter(p => p.min !== null);
                      
                      if (prices.length > 0) {
                        const allMins = prices.map(p => p.min);
                        const allMaxes = prices.map(p => p.max);
                        const overallMin = Math.min(...allMins);
                        const overallMax = Math.max(...allMaxes);
                        ticketPriceDisplay = overallMin === overallMax 
                          ? `$${overallMin}` 
                          : `$${overallMin} - $${overallMax}`;
                        if (hasDonation) ticketPriceDisplay += ' / Donation';
                      } else if (hasDonation) {
                        ticketPriceDisplay = 'Donation / Pay what you can';
                      }
                    }
                  } else if (event.ticket_price && event.ticket_price !== "") {
                    ticketPriceDisplay = event.ticket_price.includes("$") 
                      ? event.ticket_price 
                      : "$" + event.ticket_price;
                  }
                  
                  return event.ticketed && ticketPriceDisplay && (
                    <div className="event-detail-amenity">
                      -this event is ticketed, cost :{" "}
                      <span
                        style={{
                          fontFamily: "Primary-Regular",
                          color: "var(--inyc-details-light-color)",
                        }}
                      >
                        {ticketPriceDisplay}
                      </span>
                    </div>
                  );
                })()}
                
                {/* Ticket cards section */}
                <TicketCardsSection 
                  event={event}
                  trackSessionEvent={trackSessionEvent}
                  ensureValidUrl={ensureValidUrl}
                  previewOnly={previewOnly}
                />
                {event.age_restriction && (
                  <div className="event-detail-amenity event-detail-amenity--after-tickets">
                    this {event.type} is{" "}
                    <span
                      style={{
                        fontFamily: "Primary-Regular",
                        color: "var(--inyc-details-light-color)",
                      }}
                    >
                      {event.age_restriction}+
                    </span>
                  </div>
                )}

                {event.account_id && (
                  <div className="mb-kit-32 mt-kit-24">
                    <div className="inyc-label is-sm">posted by</div>
                    <div className="poster-info-container">
                      <div className="inyc-card is-sm poster-info-card">
                        <div 
                          className="poster-info-clickable"
                          onClick={previewOnly ? undefined : () => selectAccount(event.account_id)}
                        >
                          <div className="poster-avatar">
                            {event.account_id.profilePicture ? (
                              <img
                                src={event.account_id.profilePicture}
                                alt={event.account_id.businessName || `${event.account_id.firstName} ${event.account_id.lastName}`}
                                className="poster-avatar-image"
                              />
                            ) : (
                              <FaUser size={14} color="var(--inyc-primary-color)" />
                            )}
                          </div>
                          <div className="poster-details">
                            <div className="poster-name">
                              {event.account_id.accountType === "business" 
                                ? (event.account_id.businessName || `${event.account_id.firstName} ${event.account_id.lastName}`)
                                : `${event.account_id.firstName} ${event.account_id.lastName}`
                              }
                            </div>
                            {event.account_id.accountType && (
                              <span className="inyc-badge is-sm">
                                {event.account_id.accountType === "artist" ? "artist" : 
                                 event.account_id.accountType === "business" ? "business" : "user"}
                              </span>
                            )}
                          </div>
                        </div>
                        {!previewOnly && (
                          <IconButton
                            label={user?.following?.includes(event.account_id?._id) ? "unwatch" : "watch"}
                            icon={user?.following?.includes(event.account_id?._id) ? <FaEye /> : <FaRegEye />}
                            onClick={toggleFollow}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {/* minimap - temporarily disabled */}
                {/* {event.location && ( */}
                {/* <div className="rounded-kit-md mt-kit-24 overflow-hidden mb-kit-24">
                  <MiniMap
                    userLocation={userLocation}
                    event={event}
                    key={event._id}
                    style={miniMapStyle}
                  />
                </div> */}
              </div>
            </div>
          </div>
          {/* venu events */}
          <div className={`mt-kit-6 mb-[5rem] ${event.type === "venue" && !isVenueEventsView ? "hidden" : ""}`}>
            {event.type === "venue" && (
              <>
                <div
                  className={`grid overflow-hidden duration-200 ${
                    venueSearchOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="min-h-0">
                    <div className="venue-events-search-input-row mx-kit-16 flex items-center gap-kit-8">
                      <div className="relative flex-1 min-w-0">
                      <Input
                        placeHolder="search events at this venue"
                        Ref={searchInputRef}
                        onChange={(e) => setQueryFilter(e.target.value)}
                        value={queryFilter}
                        icon={<FiSearch size={16} />}
                        onKeyDown={handleSearchKeyDown}
                        className={
                          "search-filters-input !mt-0 !mx-0"
                        }
                      />
                      {queryFilter && queryFilter.trim().length > 0 && (
                        <IconButton
                          size="xs"
                          label="clear search"
                          icon={<IoMdClose />}
                          className="absolute top-1/2 right-[0.5rem] -translate-y-1/2 z-10"
                          onClick={() => setQueryFilter("")}
                        />
                      )}
                      </div>
                      <Chip
                        aria-label="filters"
                        aria-expanded={venueFilterOpen}
                        selected={Boolean(
                          venueFilterOpen ||
                            (dateFilter && !isDefaultDateFilter(dateFilter)) ||
                            tagFilter?.length > 0
                        )}
                        icon={<IoFilter size={16} />}
                        onClick={() => setVenueFilterOpen((open) => !open)}
                      />
                    </div>
                  </div>
                </div>
                {/* Collapsible filters section */}
                <div
                  className={`grid overflow-hidden duration-200 ${
                    venueFilterOpen && venueSearchOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="min-h-0">
                    <BottomSheetDateFilter
                      filterDate={dateFilter}
                      setFilterDate={setDateFilter}
                      tagFilter={tagFilter}
                      setTagFilter={setTagFilter}
                      className={"!relative md:!min-w-full md:!w-full"}
                      hideFilterIcon={true}
                      alwaysShowTags={true}
                    />
                  </div>
                </div>
                {detailsSearchLoading && (
                  <div className="fixed left-[50%] translate-x-[-50%] p-[5rem] ">
                    <Loader />
                  </div>
                )}
                {event.events?.length > 0 || filteredEvents?.length > 0 ? (
                  <>
                    <InfiniteScroller
                      className={detailsSearchLoading ? "opacity-20" : ""}
                      items={eventItems}
                      renderer={(item, index) => {
                        return (
                          <EventCard
                            key={index}
                            disabled={filtersActive && !item._filterEvent}
                            data={{
                              ...item,
                              timezone: item.timezone || event.timezone,
                            }}
                            className={`map-event-container`}
                            fullWidth
                            onClick={() => handleEventCardClick(item)}
                          />
                        );
                      }}
                    />
                  </>
                ) : (
                  <div className="map-events-none">no upcoming events</div>
                )}
              </>
            )}
          </div>
        </div>
      ) : (
        <div className="event-detail-container">
          <Loader />
        </div>
      )}
    </>
  );
};


// Simple memoization that works
const MemoizedEventDetails = React.memo(EventDetails, (prevProps, nextProps) => {
  // Only re-render if data actually changes
  return prevProps.data === nextProps.data;
});

export default MemoizedEventDetails;
